import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import NumberInput from '../../Common/numberInput';
import Validator from '../../Common/validator';

class ThirdActivity extends Component {
  componentWillMount = () => {
    // eslint-disable-next-line
    if (this.props.thirdActivityCount == this.props.index && this.props.third.name.value) {
      this.props.addNewField()
    }
  };
  shouldComponentUpdate = (nextProps) => {
    // eslint-disable-next-line
    if (nextProps.rowShouldUpdate.thirdKey == this.props.index || nextProps.rowShouldUpdate.thirdKey == 0) {
      return true
    }
    return false;
  };
  onChangeWrap = (evt, inputTarget) => {
    this.props.setRowShouldUpdate();
    inputTarget.onChange(evt);
  };
  onBlurWrap = (evt, inputTarget) => {
    this.props.setRowShouldUpdate();
    inputTarget.onBlur(evt);
  };
  calcSumField = (val1, val2) => {
    const { third } = this.props;
    if ((!val1 && val1 !== 0) || (!val2 && val2 !== 0)) {
      third.sum.onChange(null);
    }
    else {
      let roundedNumber = Math.round(val1 * val2 * 10) / 10;
      third.sum.onChange(roundedNumber);
    }
  };
  render() {
    const { styles, rootKey, secondKey, index, third, isEdit } = this.props;
    let indexKey = rootKey + "." + secondKey + "." + index;
    return (
      <div className="row" key={indexKey} style={styles.activityContainer}>
        <div style={[styles.firstInThirdRow]} className={third.name.valid ? "col-sm-4" : "col-sm-4 error"} >
          <div style={[styles.indexKey, styles.indexKeyThird]}>{indexKey}</div>
          <Validator
            isValid={!third.name.touched || third.name.valid}>
            <input
              className="form-control"
              type="text"
              placeholder={!(!third.name.touched || third.name.valid) ? third.name.error : third.name.initialValue ? third.name.initialValue : "Aktivitet"}
              style={[styles.thirdInputField, styles.inputField, styles.inputFieldName]}
              onBlur={(evt) => {
                // eslint-disable-next-line
                if (evt.target.value == "" && third.name.initialValue && isEdit) {
                  evt.target.value = third.name.initialValue
                }
                this.onBlurWrap(evt, third.name)
              }}
              value={third.name.value ? third.name.value : ''}
              onChange={(evt) => {
                this.onChangeWrap(evt, third.name)
                // if addNewField is a fucntion, then add new field
                if (this.props.addNewField) this.props.addNewField();
              }}
            />
          </Validator>
        </div>
        <div className={third.unit.valid ? "col-sm-2" : "col-sm-2 error"} style={styles.col}>
          <Validator
            isValid={!third.unit.touched || third.unit.valid}>
            <input
              className="form-control"
              type="text"
              placeholder={!(!third.unit.touched || third.unit.valid) ? third.unit.error : "Enh"}
              style={[styles.thirdInputField, styles.inputField]}
              value={third.unit.value ? third.unit.value : ''}
              onBlur={(evt) => { this.onBlurWrap(evt, third.unit) }}
              onChange={(evt) => { this.onChangeWrap(evt, third.unit) }}
            />
          </Validator>
        </div>
        <div className={third.amount.valid ? "col-sm-2" : "col-sm-2 error"} style={styles.col}>
          <Validator
            isValid={!third.amount.touched || third.amount.valid}>
            <NumberInput
              disableClearOnEnter={true}
              style={[styles.thirdInputField, styles.inputField]}
              placeHolder={!(!third.amount.touched || third.amount.valid) ? third.amount.error : "Mgd"}
              {...third.amount}
              onBlur={(evt) => {
                this.onBlurWrap(evt, third.amount)
              }}
              onChange={(evt) => {
                this.calcSumField(evt, third.hoursPerUnit.value);
                this.onChangeWrap(evt, third.amount)
              }}
            />
          </Validator>
        </div>
        <div className={third.hoursPerUnit.valid ? "col-sm-2" : "col-sm-2 error"} style={styles.col}>
          <Validator
            isValid={!third.hoursPerUnit.touched || third.hoursPerUnit.valid}>
            <NumberInput
              disableClearOnEnter={true}
              style={[styles.thirdInputField, styles.inputField]}
              placeHolder={!(!third.hoursPerUnit.touched || third.hoursPerUnit.valid) ? third.hoursPerUnit.error : "Timer/enh"}
              {...third.hoursPerUnit}
              onBlur={(evt) => {
                this.onBlurWrap(evt, third.hoursPerUnit)
              }}
              onChange={(evt) => {
                this.calcSumField(evt, third.amount.value);
                this.onChangeWrap(evt, third.hoursPerUnit)
              }}
            />
          </Validator>
        </div>
        <div className="col-sm-2" style={styles.col}>
          <input
            className="form-control"
            type="text"
            disabled={true}
            value={third.sum.value ? third.sum.value : ''}
            placeholder="Sum"
            style={[styles.thirdInputField, styles.inputField]}
          />
        </div>
      </div>
    );
  }
}
ThirdActivity.propTypes = {
  third: PropTypes.object.isRequired,
  secondKey: PropTypes.number.isRequired,
  rootKey: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  setRowShouldUpdate: PropTypes.func.isRequired,
  rowShouldUpdate: PropTypes.object.isRequired,
  addNewField: PropTypes.func,
  isEdit: PropTypes.bool.isRequired
};
export default Radium(ThirdActivity)


// WEBPACK FOOTER //
// ./src/App/Project/CreateProject/thirdActivity.jsx